var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "session-termination" },
    [
      _c(
        "div",
        { staticClass: "session-termination-header" },
        [
          !_vm.aiRecommendation
            ? _c(
                "SupsisButton",
                {
                  staticClass: "ai-suggest-button",
                  attrs: { disabled: _vm.copilotWaiting },
                  on: { click: _vm.handleAIRecommendation },
                },
                [
                  _vm.copilotWaiting
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "rotating-border rotating-border--rainbow",
                        },
                        [
                          _c("img", {
                            staticClass: "copilot-icon",
                            attrs: { src: "/static/img/copilot.png" },
                          }),
                        ]
                      )
                    : _c("img", {
                        staticClass: "copilot-icon",
                        attrs: { src: "/static/img/copilot.png" },
                      }),
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("message.aiSuggestion")) +
                      "\n        "
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "session-termination-content" }, [
        _vm.aiRecommendation && !_vm.allRecommendationsApplied
          ? _c("div", { staticClass: "ai-recommendation-section" }, [
              _c(
                "div",
                { staticClass: "ai-header" },
                [
                  _c("div", { staticClass: "ai-header-left" }, [
                    _c("img", {
                      staticClass: "copilot-icon",
                      attrs: {
                        src: "/static/img/copilot.png",
                        width: "17",
                        height: "17",
                      },
                    }),
                    _vm._v(" "),
                    _c("h3", [
                      _vm._v(_vm._s(_vm.$t("message.aiSuggestionTitle"))),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "SupsisButton",
                    {
                      staticClass: "ai-action-button apply-all-button",
                      on: { click: _vm.applyAllRecommendations },
                    },
                    [
                      _c("span", { staticClass: "material-icons" }, [
                        _vm._v("auto_fix_high"),
                      ]),
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("message.applyAll")) +
                          "\n                "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "ai-recommendation-item" },
                [
                  _c("div", { staticClass: "ai-content" }, [
                    _c("h4", [_vm._v(_vm._s(_vm.$t("message.suggestedNote")))]),
                    _vm._v(" "),
                    _c("p", [_vm._v(_vm._s(_vm.aiRecommendation.note))]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "SupsisButton",
                    {
                      staticClass: "ai-action-button",
                      on: { click: _vm.applyNoteRecommendation },
                    },
                    [_vm._v(_vm._s(_vm.$t("ticimax.apply")))]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.aiRecommendation.tags.length
                ? _c(
                    "div",
                    { staticClass: "ai-recommendation-item" },
                    [
                      _c("div", { staticClass: "ai-content" }, [
                        _c("h4", [
                          _vm._v(_vm._s(_vm.$t("message.suggestedTags"))),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "tags-container" },
                          _vm._l(_vm.getRecommendedTags, function (tag) {
                            return _c(
                              "span",
                              {
                                key: tag._id,
                                staticClass: "tag-label",
                                style: _vm.getTagStyle(tag.color),
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(tag.name) +
                                    "\n                        "
                                ),
                              ]
                            )
                          }),
                          0
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "SupsisButton",
                        {
                          staticClass: "ai-action-button",
                          on: { click: _vm.applyTagRecommendation },
                        },
                        [_vm._v(_vm._s(_vm.$t("ticimax.apply")))]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.aiRecommendation.contactProperties.length
                ? _c(
                    "div",
                    { staticClass: "ai-recommendation-item" },
                    [
                      _c("div", { staticClass: "ai-content" }, [
                        _c("h4", [
                          _vm._v(
                            _vm._s(_vm.$t("message.suggestedProfileFields"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "property-list" },
                          _vm._l(
                            _vm.mappedPropertyRecommendations,
                            function (prop) {
                              return _c(
                                "div",
                                {
                                  key: prop.propertyId,
                                  staticClass: "property-item",
                                },
                                [
                                  _c("span", { staticClass: "prop-name" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.getPropertyName(prop.propertyId)
                                      ) + ":"
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "prop-value" }, [
                                    _vm._v(_vm._s(prop.propertyValue)),
                                  ]),
                                ]
                              )
                            }
                          ),
                          0
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "SupsisButton",
                        {
                          staticClass: "ai-action-button",
                          on: { click: _vm.applyPropertyRecommendation },
                        },
                        [_vm._v(_vm._s(_vm.$t("ticimax.apply")))]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "section-row" }, [
          _c(
            "div",
            { staticClass: "section notes-section" },
            [
              _c("div", { staticClass: "section-header" }, [
                _c("div", { staticClass: "section-title" }, [
                  _c("span", { staticClass: "material-icons" }, [
                    _vm._v("note_add"),
                  ]),
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.$t("message.addNote")) +
                      "\n                    "
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "section-description" }, [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.$t("message.noteDescription")) +
                      "\n                    "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("a-textarea", {
                attrs: {
                  placeholder: _vm.$t("message.enterNote"),
                  "auto-size": { minRows: 2, maxRows: 4 },
                },
                model: {
                  value: _vm.note,
                  callback: function ($$v) {
                    _vm.note = $$v
                  },
                  expression: "note",
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "note-privacy" },
                [
                  _c(
                    "a-checkbox",
                    {
                      model: {
                        value: _vm.isPrivateNote,
                        callback: function ($$v) {
                          _vm.isPrivateNote = $$v
                        },
                        expression: "isPrivateNote",
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("message.privateNote")) + " ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "section tags-section" },
            [
              _c("div", { staticClass: "section-header" }, [
                _c("div", { staticClass: "section-title" }, [
                  _c("span", { staticClass: "material-icons" }, [
                    _vm._v("label"),
                  ]),
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.$t("message.manageTags")) +
                      "\n                    "
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "section-description" }, [
                  _vm._v(
                    "\n                       " +
                      _vm._s(_vm.$t("message.categoryTags")) +
                      "\n                    "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "tags-container" },
                _vm._l(_vm.mappedTags, function (tag) {
                  return _c(
                    "span",
                    {
                      key: tag._id,
                      staticClass: "tag-label",
                      style: _vm.getTagStyle(tag.color),
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "remove-tag",
                          on: {
                            click: function ($event) {
                              return _vm.removeTag(tag._id)
                            },
                          },
                        },
                        [_vm._v("×")]
                      ),
                      _vm._v(
                        "\n                        " +
                          _vm._s(tag.name) +
                          "\n                    "
                      ),
                    ]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c(
                "a-button",
                {
                  staticStyle: { "margin-top": "8px" },
                  attrs: { type: "dashed", icon: "plus" },
                  on: {
                    click: function ($event) {
                      _vm.showTagDialog = true
                    },
                  },
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("message.addTag")) +
                      "\n                "
                  ),
                ]
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _vm.contactProperties.length > 0
          ? _c("div", { staticClass: "section properties-section" }, [
              _c("div", { staticClass: "section-header" }, [
                _c("div", { staticClass: "section-title" }, [
                  _c("span", { staticClass: "material-icons" }, [
                    _vm._v("contact_mail"),
                  ]),
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("visitor.profileFields")) +
                      "\n                "
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "section-description" }, [
                  _vm._v(
                    "\n                   " +
                      _vm._s(_vm.$t("message.profileFieldsDescription")) +
                      "\n                "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "profile-fields" },
                [
                  _c("ContactProperties", {
                    ref: "contactPropertiesRef",
                    attrs: {
                      contact: _vm.contact,
                      "show-widget-title": false,
                      columns: 3,
                      draggable: false,
                      orderable: false,
                      "max-visible-rows": 2,
                      "show-more": _vm.showMoreProperties,
                      "show-info": false,
                    },
                  }),
                  _vm._v(" "),
                  _vm.contactProperties && _vm.contactProperties.length > 6
                    ? _c(
                        "div",
                        { staticClass: "show-more-container" },
                        [
                          _c(
                            "a-button",
                            {
                              attrs: { type: "link" },
                              on: { click: _vm.toggleShowMore },
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.showMoreProperties
                                      ? _vm.$t("message.showLess")
                                      : _vm.$t("message.showMore")
                                  ) +
                                  "\n                        "
                              ),
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.showMoreProperties
                                      ? "keyboard_arrow_up"
                                      : "keyboard_arrow_down"
                                  )
                                ),
                              ]),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "session-termination-footer" },
        [
          _c("a-button", { on: { click: _vm.handleCancel } }, [
            _vm._v(" " + _vm._s(_vm.$t("message.cancelText")) + " "),
          ]),
          _vm._v(" "),
          _c(
            "a-button",
            {
              attrs: { type: "primary", loading: _vm.isTerminating },
              on: { click: _vm.handleTerminate },
            },
            [_vm._v(" " + _vm._s(_vm.$t("message.endChat")) + " ")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.showTagDialog
        ? _c(
            "Modal2",
            {
              attrs: { title: _vm.$t("message.manageTags"), showFooter: false },
              on: {
                cancel: function ($event) {
                  _vm.showTagDialog = false
                },
              },
            },
            [
              _c("TagDialog", {
                attrs: { value: _vm.selectedTagIds, inlineMode: true },
                on: {
                  input: _vm.handleTagUpdate,
                  close: function ($event) {
                    _vm.showTagDialog = false
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }